import { Injectable } from '@angular/core';
import { UntypedFormArray } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ConfirmationDialogService } from '../../components/confirmation-dialog/confirmation-dialog.service';
import { DialogDataModel } from '../../shared/models/dialog-data.interface';

@Injectable({
  providedIn: 'root'
})
export class StatusCheckService {

  addedElementFormArray = new UntypedFormArray([]);

  constructor(
    private _confirmDialogService: ConfirmationDialogService,
    private _translate: TranslateService
  ) {
  }

  /**
   * Get main element status
   */
  getMainElementStatus(): boolean {
    this.checkStatusOfFormArray();
    const status = (sessionStorage.getItem('isMainElementPristine') === 'true');
    if (status) {
      this.addedElementFormArray = new UntypedFormArray([]);
      this.addedElementFormArray.markAsPristine();
    }
    return status;
  }

  /**
   * Checking added element status and save
   */
  checkStatusOfFormArray() {
    sessionStorage.setItem('isMainElementPristine', this.addedElementFormArray.pristine.toString());
  }

  /**
   * Confirm before close/ open the drawer/ harmonica
   */
  openConfirmation(): Observable<boolean> {
    const dialogData: DialogDataModel = {
      title: this._translate.instant('MESSAGES.CONFIRMATION'),
      message: this._translate.instant('MESSAGES.ARE_YOU_SURE_CONTINUE'),
      hasCancelBtn: true
    }
    return this._confirmDialogService.openDialog(dialogData).afterClosed()
      .pipe(
        tap((resp) => {
          if (resp) {
            this.addedElementFormArray = new UntypedFormArray([]);
          }
        })
      );
  }


  deleteFormGroup(index: number) {
    if (this.addedElementFormArray.length < 1) {
      this.addedElementFormArray.markAsPristine();
      return;
    }

    this.addedElementFormArray.removeAt(index);
    const result = this.addedElementFormArray.controls.find((formGroup) => !formGroup.pristine);
    if (!result) {
      this.addedElementFormArray.markAsPristine();
    }
  }

  openDataSetChangeConfirmation(): Observable<boolean> {
    const dialogData: DialogDataModel = {
      title: this._translate.instant('MESSAGES.CONFIRMATION'),
      message: this._translate.instant('MESSAGES.DATASET_CONFIRMATION'),
      hasCancelBtn: true
    }
    return this._confirmDialogService.openDialog(dialogData).afterClosed()
      .pipe(
        tap((resp) => {
          if (resp) {
            this.addedElementFormArray = new UntypedFormArray([]);
          }
        })
      );
  }

}
